import { BacksplashState } from './BacksplashState';
import { HoodState } from './HoodState';
import { RangeState } from './RangeState';

export class Summary {
  /**
   * The summary information of the configured range.
   * @type {RangeState}
   */
  #range;

  /**
   * The summary information of the configured hood.
   * @type {HoodState}
   */
  #hood;

  /**
   * The summary information of the configured backsplash.
   * @type {BacksplashState}
   */
  #backsplash;

  /**
   * @param {RangeState} range
   * @param {HoodState} hood
   * @param {BacksplashState} backsplash
   */
  constructor(range, hood, backsplash) {
    this.#range = range;
    this.#hood = hood;
    this.#backsplash = backsplash;
  }

  /**
   * The summary link for a configured range, hood, and backsplash.
   * @returns {string}
   */
  summaryLink() {
    return `#summary/${this.#range.slug()}`;
  }

  /**
   * The query parameter for a configured range.
   * @returns {string}
   */
  #rangeParam() {
    return `range=${this.#range.slug()}${this.#range.voltsParam()}`;
  }

  /**
   * The query parameter for a configured hood.
   * @returns {string}
   */
  #hoodParam() {
    if (!this.#hood.isSelected) {
      return '';
    }

    return `&hood=${this.#hood.slug()}`;
  }

  /**
   * The query parameter for a backsplash.
   * @returns {string}
   */
  #backsplashParam() {
    if (!this.#backsplash.isSelected) {
      return '';
    }

    return `&backsplash=${this.#backsplash.slug()}`;
  }
}
